import React, { ReactElement } from 'react';

import DocumentRouter from '@bessemercws/documents';
import { isUserProfileType, UserProfileType } from '@bessemercws/graphql';
import { App as PreferencesRouter } from '@bessemercws/preferences';

export interface RouteElementProps {
  isAdvisor?: boolean;
  token?: string;
  clientId?: string;
  subscriptionChannel: string;
  userProfileType: string | undefined;
  onNavigateHome?: () => void;
}

export const routesByUserProfileType: Record<UserProfileType, { 
  homeRoute: string,
  routes: (props: RouteElementProps) => { withHeaderRoutes: [{ path: string, element: ReactElement }], customBodyRoutes: [{ path: string, element: ReactElement }]}
}> = {
  Tax : {
    homeRoute: '/documents/tax',
    routes: (props: RouteElementProps) => ({
      withHeaderRoutes: [
        {
          path: "preferences/*",
          element: <PreferencesRouter userProfileType={props.userProfileType} />
        }
      ],
      customBodyRoutes: [
        {
          path: 'documents/*',
          element: <DocumentRouter 
            token={props.token} 
            clientId={props.clientId}
            subscriptionChannel={props.subscriptionChannel} 
            userProfileType={props.userProfileType}
            onNavigateHome={props.onNavigateHome} />,
        }
      ]
    })
  }
}

export const emulationRoutesByUserProfileType: Record<UserProfileType, { 
  homeRoute: string,
  routes: (props: RouteElementProps) => { withHeaderRoutes: [{ path: string, element: ReactElement }], customBodyRoutes: [{ path: string, element: ReactElement }]}
}> = {
  Tax: {
    homeRoute: '/documents/tax',
    routes: (props: RouteElementProps) => ({
      withHeaderRoutes: [
        {
          path: "preferences/*",
          element: <PreferencesRouter isAdvisor={props.isAdvisor} userProfileType={props.userProfileType} />
        }
      ],
      customBodyRoutes: [
        {
          path: 'documents/*',
          element: <DocumentRouter
            isAdvisor={props.isAdvisor}
            token={props.token} 
            clientId={props.clientId}
            subscriptionChannel={props.subscriptionChannel} 
            userProfileType={props.userProfileType}
            onNavigateHome={props.onNavigateHome} />,
        }
      ]
    })
  }
}

export function getHomeRoute(userProfileType?: string | undefined | null): string {
  if (userProfileType && isUserProfileType(userProfileType) && routesByUserProfileType[userProfileType]) {
    return routesByUserProfileType[userProfileType].homeRoute;
  } else {
    return '/';
  }
}
